import {EditContract} from './edit-contract';

export default EditContract;
